import { createSlice } from '@reduxjs/toolkit';
import { CLEAR_RADAR_USER_DATA } from '../radarUserProfile';
import { createSliceSelector } from '../../utils/selectors';
import { LOGOUT_SUCCESSFUL } from '../../reducers/auth';

const name = 'radarConnections';

const initialState = {
  // friend fetched by submitting friend code or invitation or friend from the list
  searchedFriend: null,

  // search phrase, can be friend code
  search: '',
};

const radarConnectionsSlice = createSlice({
  name,
  initialState,
  reducers: {
    setSearch(state, action) {
      state.search = action.payload;
    },
    setSearchedFriend(state, action) {
      state.searchedFriend = action.payload;
    },
    clearFriendSearch(state) {
      state.searchedFriend = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CLEAR_RADAR_USER_DATA, () => initialState)
      .addCase(LOGOUT_SUCCESSFUL, () => initialState);
  },
});
export const { setSearch, clearFriendSearch, setSearchedFriend } =
  radarConnectionsSlice.actions;

export const radarConnectionsSelector = createSliceSelector(
  radarConnectionsSlice,
);

export default { [name]: radarConnectionsSlice.reducer };
